import useEmblaCarousel from 'embla-carousel-react';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { api_getProductsByIds, api_searchProducts } from '~/backend/api_calls';
import { sendViewItemListGTMEvent } from '~/common/gtm';
import ProductBox from './ProductBox';

const ProductCarousel = ({ productTabEntry, classActive }) => {
	const [products, setProducts] = useState([]);
	const [emblaRef2, emblaApi2] = useEmblaCarousel({ loop: true, slidesToScroll: 2 });
	let searchParameters = {
		enrich: true,
		keyword: '',
		pageIndex: 0,
		pageSize: 6,
		categoryIds: '',
		status: 0
	};

	useEffect(() => {
		{
			/*if (!classActive.includes("active") || products.length > 0)
            return;*/
		}

		if (productTabEntry.mode === 0) {
			api_getProductsByIds(productTabEntry.product_ids.join(','))
				.then(json => {
					setProducts(json.items);
					//gtm
					sendViewItemListGTMEvent(json.items, 0, productTabEntry.nm);
				})
				.catch(error => {
					console.error(error);
				});
		} else {
			searchParameters.categoryIds = productTabEntry.cid;
			searchParameters.status = productTabEntry.mode;
			api_searchProducts(searchParameters)
				.then(json => {
					setProducts(json.prds);
				})
				.catch(error => {
					console.error(error);
				});
		}
	}, [classActive]);

	useEffect(() => {
		if (products.length > 0 && emblaApi2) {
			emblaApi2.reInit(); // Reinitialize the carousel when products are loaded
		}
	}, [products, emblaApi2]);

	const scrollPrev = useCallback(() => {
		if (emblaApi2) emblaApi2.scrollPrev();
	}, [emblaApi2]);

	const scrollNext = useCallback(() => {
		if (emblaApi2) emblaApi2.scrollNext();
	}, [emblaApi2]);

	return (
		<div ref={emblaRef2} className={classActive}>
			<div className="embla__container">
				{products.map((item, index) => (
					<div className="embla__slide" key={index}>
						<ProductBox idx={index} key={index} product={item} listName={productTabEntry.nm} />
					</div>
				))}
			</div>

			<div className="embla_controls">
				<button className="embla_control embla__prev" onClick={scrollPrev} title="Previous">
					<svg xmlns="http://www.w3.org/2000/svg" width="7.095" height="12.69" viewBox="0 0 7.095 12.69">
						<path
							id="Path_38025"
							data-name="Path 38025"
							d="M18,7.5l5.815,5.815L18,19.129"
							transform="translate(-17.47 -6.97)"
							fill="none"
							stroke="#000"
							strokeLinejoin="round"
							strokeWidth="1.5"
						/>
					</svg>
				</button>

				<button className="embla_control embla__next" onClick={scrollNext} title="Next">
					<svg xmlns="http://www.w3.org/2000/svg" width="7.095" height="12.69" viewBox="0 0 7.095 12.69">
						<path
							id="Path_38025"
							data-name="Path 38025"
							d="M18,7.5l5.815,5.815L18,19.129"
							transform="translate(-17.47 -6.97)"
							fill="none"
							stroke="#000"
							strokeLinejoin="round"
							strokeWidth="1.5"
						/>
					</svg>
				</button>
			</div>
		</div>
	);
};

ProductCarousel.propTypes = {
	productTabEntry: PropTypes.object,
	classActive: PropTypes.string
};

export default ProductCarousel;
